angular.module('impactx.logouttimer').directive('ixLogoutTimer', [function() {
    return {
        scope: true,
        templateUrl: 'shared/logouttimer/templates/timer.tmpl.html',
        controller: "LogoutTimerCtrl"
    }
}]);

